import { IApplicant, ApplicantsService, EnumService, IEmployee, EmployeesService } from "../../../services/index";
import * as moment from 'moment';

interface IResolve {
    applicant: IApplicant;
    preferredTargetAudiences: any;
    applicationStatuses: any;
    functions: any;
}


class ApplicantsItemEmployeeController {

    private resolve: IResolve;
    private applicant: IApplicant;
    public employee: any;
    functions: any;
    applicationStatuses: any;


    constructor(
        private EnumService: EnumService,
        private ApplicantsService: ApplicantsService,
        private EmployeesService: EmployeesService,
        private $state: ng.ui.IStateService
    ) {
        'ngInject';
    }


    public $onInit = () => {
        this.applicant = this.resolve.applicant;
        this.functions = this.resolve.functions;
        this.applicationStatuses = this.resolve.applicationStatuses;

        this.employee = {};
        this.employee.homeAddress = {};

        this.employee.firstName = this.applicant.name.split(' ')[0];

        const names = this.applicant.name.split(' ');
        names.shift();
        this.employee.lastName = names.join(' ');

        this.employee.telephoneMobilePrivate = this.applicant.phoneNumber;
        this.employee.emailPrivate = this.applicant.email;
        this.employee.homeAddress.city = this.applicant.city;
        this.employee.functionId = this.applicant.functionId;
        this.employee.zzp = this.applicant.zzp;

    }

    public save = () => {

        this.EmployeesService.post(this.employee).then((employee: IEmployee) => {

            this.applicant.employeeId = employee.id
            this.applicant.applicationStatusId = this.applicationStatuses.find(s => s.code == 'accepted').id;

            this.ApplicantsService.put(this.applicant.id, this.applicant).then((applicant: IApplicant) => {
                this.$state.go('hr.employees.item', { 'id': applicant.employeeId });
            });

        });

    }

    private closeModal() {
        this.$state.go('^', {}, { reload: true });
    }
}

export const applicantsItemEmployeeComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: ApplicantsItemEmployeeController,
    template: require('./applicants.item.employee.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/applicants/applicants.item.employee.component.ts